import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import EventForm from "./AddEvent";

export default function EditBlog() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <EventForm
      isEdit={true}
      eventId={id}
      onSuccess={() => navigate("/listevents")}
    />
  );
}